import { get, post } from './request'
import qiniuUpload from './upload'

const http = {
  // 登录
  companyLogin(params) {
    return post('/publiclib/companyLogin', params)
  },
  // 检查是否已经登录
  checkLogin(params) {
    return post('/publiclib/checkLogin', params)
  },
  // 退出登录
  loginout(params) {
    return get('/publiclib/loginout', params)
  },
  // 获取菜单栏
  getMenuData(params) {
    return post('/index/getmenu', params)
  },
  // 商学院-目录列表
  getDirectoryList(params) {
    return post('/Article/directoryList', params)
  },
  // 商学院-获取资料列表
  getArticleList(params) {
    return post('/Article/getArticleList', params)
  },
  // 商学院-获取目录tree
  getDirectoryListTree(params) {
    return post('/Article/getDirectoryList', params)
  },
  // 商学院-目录排序
  setDirectorySort(params) {
    return post('/Article/setDirectorySort', params)
  },
  // 商学院-目录新增编辑
  improveDirectory(params) {
    return post('/Article/improveDirectory', params)
  },
  // 商学院-目录删除(逻辑)
  getDirectoryRemove(params) {
    return post('/Article/directoryRemove', params)
  },
  // 商学院-目录详情
  getDirectoryInfo(params) {
    return post('/Article/getDirectoryInfo', params)
  },
  // 商学院-获取分类目录下的资料列表
  getArticleListByDirectory(params) {
    return post('/Article/getArticleListByDirectory', params)
  },
  // 商学院-分类内容批量移除
  getArticleRemoveAssociate(params) {
    return post('/Article/articleRemoveAssociate', params)
  },
  // 商学院-分类内容排序
  setArticleSort(params) {
    return post('/Article/setArticleSort', params)
  },
  // 商学院-按标题搜索资料
  searchArticleListByOtherDirectory(params) {
    return post('/Article/searchArticleListByOtherDirectory', params)
  },
  // 商学院-批量添加分类资料
  getArticleAssociated(params) {
    return post('/Article/articleAssociated', params)
  },
  // 获取全年工作日
  getCalendarData(params) {
    return post('/Company/getCalendarData', params)
  },
  // 刷新批改工作时间
  syncCorrectWorkDay(params) {
    return post('/Company/syncCorrectWorkDay', params)
  },
  // 设置工作日
  setCalendarData(params) {
    return post('/Company/setCalendarData', params)
  },
  // 获取人工月信息
  getArtificialCalendar(params) {
    return post('/Company/getArtificialCalendar', params)
  },
  // 设置人工月信息
  setArtificialCalendar(params) {
    return post('/Company/setArtificialCalendar', params)
  },
  // 设置扣费方式变更列表
  changeDeductionMethod(params) {
    return post('/Company/changeDeductionMethod', params)
  },
  // 变更扣费类型
  changeDeductionMethodSubmit(params) {
    return post('/Company/changeDeductionMethodSubmit', params)
  },
  // 获取资料详情
  // 获取资料详情 可对外
  getArticleShow(params) {
    return post('/Article/articleShow', params)
  },
  // 商学院-资料删除(逻辑)
  articleRemove(params) {
    return post('/Article/articleRemove', params)
  },
  // 商学院-资料发布 撤回
  articleIssue(params) {
    return post('/Article/articleIssue', params)
  },
  // 商学院-资料新增编辑
  improveArticle(params) {
    return post('/Article/improveArticle', params)
  },
  // 商学院-获取资料详情
  getArticleInfo(params) {
    return post('/Article/getArticleInfo', params)
  },
  // 七牛图片token
  imgToken(params) {
    return post(qiniuUpload.imgToken, params)
  },
  // 七牛文件token
  fToken(params) {
    return post(qiniuUpload.fileToken, params)
  },
  // 将文件url上传到后端库
  filesImprove(params) {
    return post('http://third.tuolele.cn/folder.php/index/filesImprove', params)
  },
  // 获取店铺列表
  getShopList(params) {
    return post('/Company/getShopList', params)
  },
  // 设置打印机信息
  setPrinterInfo(params) {
    return post('/Company/setPrinterInfo', params)
  },
  // 获取店铺绑定的打印机信息
  getPrinterInfo(params) {
    return post('/Company/getPrinterInfo', params)
  },
  // 获取打印机列表
  getPrinterList(params) {
    return post('/Company/getPrinterList', params)
  },
  // 获取教室列表
  getClassroomRoomList(params) {
    return post('/Company/getClassroomRoomList', params)
  },
  // 添加/编辑教室
  improveClassroomRoom(params) {
    return post('/Company/improveClassroomRoom', params)
  },
  // 移除教室
  removeClassroomRoom(params) {
    return post('/Company/removeClassroomRoom', params)
  },
  // 获取设备店铺列表
  getScreenShopList(params) {
    return post('/Company/getScreenList', params)
  },
  // 设备绑定店铺
  bindingShopScreen(params) {
    return post('/Company/bindingShopScreen', params)
  },
  // 获取店铺下面的学校
  getSchoolList(params) {
    return post('/Publiclib/getSchoolList', params)
  },
  // 获取店铺详情
  getShopInfo(params) {
    return post('/Company/getShopInfo', params)
  },
  // 获取公司列表
  getCompanyList(params) {
    return post('/Publiclib/getCompanyList', params)
  },
  // 新增编辑店铺详情
  shopImprove(params) {
    return post('/Company/shopImprove', params)
  },
  // 获取店铺大区列表
  getShopClassList(params) {
    return post('/Company/getShopClassList', params)
  },
  // 编辑创建店铺大区
  improveShopClass(params) {
    return post('/Company/improveShopClass', params)
  },
  // 删除大区
  delShopClass(params) {
    return post('/Company/delShopClass', params)
  },
  // 获取属于自己的校区列表
  getMyShopList(params) {
    return post('/index/getMyShopList', params)
  },
  getShops(params) {
    return post('/Publiclib/getShops', params)
  },
  getManageList(params) {
    return post('/Student/manageList', params)
  },
  updatePassword(params) {
    return post('/Company/updatePassword', params)
  },
  // 获取签约列表
  getSignList(params) {
    return post('/Order/getSignList', params)
  },
  // 获取签约审核列表
  getSignAuditList(params) {
    return post('/Order/getSignOrderAuditList', params)
  },
  // 获取托管宝订单列表
  getTgbOrderAuditList(params) {
    return post('/Order/getTgbOrderList', params)
  },
  // 获取托管宝订单审核
  auditTgbOrder(params) {
    return post('/Order/auditTgbOrder', params)
  },
  // 获取签约详情
  getOrderInfo(params) {
    return post('/Order/getOrderInfo', params)
  },
  // 获取发票信息
  getInvoice(params) {
    return post('/Order/getInvoice', params)
  },
  // 设置发票信息
  setInvoice(params) {
    return post('/Order/setInvoice', params)
  },
  // 获取退款-列表
  getRefundList(params) {
    return post('/Order/getRefundList', params)
  },
  // 获取退款审核列表
  getRefundOrderAuditList(params) {
    return post('/Order/getRefundOrderAuditList', params)
  },
  // 获取退款-详情
  getRefundInfo(params) {
    return post('/Order/getRefundInfo', params)
  },
  // 获取内转-列表
  getAdversionList(params) {
    return post('/Order/getAdversionList', params)
  },
  // 获取内转-详情
  getAdversionInfo(params) {
    return post('/Order/getAdversionInfo', params)
  },
  // 获取赠送-列表
  getGiveList(params) {
    return post('/Order/getGiveList', params)
  },
  // 获取赠送-详情
  getGiveInfo(params) {
    return post('/Order/getGiveInfo', params)
  },
  // 常规合同、赠送合同审核成功
  // auditSuccess(params) {
  //   return post('/Order/auditSuccess', params)
  // },
  // 常规合同、赠送合同审核失败
  // auditFail(params) {
  //   return post('/Order/auditFail', params)
  // },
  // 财务审核合同
  auditOrder(params) {
    return post('/Order/auditOrder', params)
  },
  // 退费-退费审核确认
  // confirmRefund(params) {
  //   return post('/Order/confirmRefund', params)
  // },
  auditRefund(params) {
    return post('/Order/auditRefund', params)
  },
  // 内转-财务审核成功
  adversionAuditSuccess(params) {
    return post('/Order/adversionAuditSuccess', params)
  },
  // 内转-财务审核失败
  adversionAuditFail(params) {
    return post('/Order/adversionAuditFail', params)
  },
  // 首页-统一接口，根据登录角色返回数据
  getToDoTasks(params) {
    return post('/Index/toDoTasks', params)
  },
  // 获取所有开关列表
  getVasList(params) {
    return post('/Switch/getVasList', params)
  },
  // 开关设置
  setVasSubmit(params) {
    return post('/Switch/setVasSubmit', params)
  },
  // 设置支付宝配置信息
  getAlipayInfo(params) {
    return post('/configuration/getAlipayInfo', params)
  },
  // 设置支付宝配置信息
  alipaySet(params) {
    return post('/configuration/alipaySet', params)
  },
  // 获取微信配置信息
  getWechatInfo(params) {
    return post('/configuration/getWechatInfo', params)
  },
  // 设置微信配置信息
  wechatSet(params) {
    return post('/configuration/wechatSet', params)
  },
  // 设置消息模版
  setIndustryAndTemplate(params) {
    return post('/configuration/setIndustryAndTemplate', params)
  },
  // 获取公司信息
  getCompanyInfo(params) {
    return post('/company/getCompanyInfo', params)
  },
  // 设置公司信息
  improveCompany(params) {
    return post('/company/improveCompany', params)
  },
  // 获取操作指南目录
  getChildrenDirectoryList(params) {
    return post('/Article/getChildrenDirectoryList', params)
  },
  // 学生详情-基本信息
  getInfoBasic(params) {
    return post('/Student/infoBasic', params)
  },
  // 学生详情-修改手机号
  changeBindingMobile(params) {
    return post('/Student/changeBindingMobile', params)
  },
  // 学生详情-店铺就读信息
  getInfoAttend(params) {
    return post('/Student/infoAttend', params)
  },
  // 学生详情-订单信息
  getInfoOrder(params) {
    return post('/Student/infoOrder', params)
  },
  // 学生详情-渠道销售信息
  getInfoChannel(params) {
    return post('/Student/infoChannel', params)
  },
  // 学生详情-积分变动信息
  getInfoPoint(params) {
    return post('/Student/infoPoint', params)
  },
  // 学生详情-停课复课信息
  getInfoAskForLeave(params) {
    return post('/Student/infoAskForLeave', params)
  },
  // 学生详情-历史小结信息
  getInfoHistoryReport(params) {
    return post('/Student/infoHistoryReport', params)
  },
  // 学生详情-回访记录信息
  getInfoVisit(params) {
    return post('/Student/infoVisit', params)
  },
  // 学生详情-出勤&课耗信息
  getInfoAttendance(params) {
    return post('/Student/infoAttendance', params)
  },
  // 通用-获取版本更新消息
  getVersionUpdateMessage(params) {
    return post('/index/getVersionUpdateMessage', params)
  },
  // 目标计划-获取目标列表
  getTargetList(params) {
    return post('/Company/getTargetList', params)
  },
  // 目标计划-设置目标
  setTarget(params) {
    return post('/Company/setTarget', params)
  },
  // 目标计划-总览数据
  getTargetPandect(params) {
    return post('/Statistics/getTargetPandect', params)
  },
  // 目标计划-完成率
  getTargetCompletionRate(params) {
    return post('/Statistics/getTargetCompletionRate', params)
  },
  // 目标计划-对比数据
  getTargetContrast(params) {
    return post('/Statistics/getTargetContrast', params)
  },
  // 通用-获取leads渠道列表
  getChannleList(params) {
    return post('/Publiclib/getChannleList', params)
  },
  // 创建leads 检测手机号码是否注册过
  checkMobile(params) {
    return post('/Leads/checkMobile', params)
  },
  // 创建leads
  createLeads(params) {
    return post('/Leads/createLeads', params)
  },
  // 账号管理-获取管理员列表
  getAccountList(params) {
    return post('/Company/getAccountList', params)
  },
  // 账号管理-获取用户详情
  getAccountInfo(params) {
    return post('/Company/getAccountInfo', params)
  },
  // 账号管理-新增编辑账号
  improveAccount(params) {
    return post('/Company/improveAccount', params)
  },
  // 账号管理-移除账号
  accountRemove(params) {
    return post('/Company/accountRemove', params)
  },
  // 通用-获取公司下的职能列表
  getObligationList(params) {
    return post('/Index/getObligationList', params)
  },
  // 通用-获取套餐类型
  getOrderType(params) {
    return post('/Publiclib/getOrderType', params)
  },
  // 通用-获取赠送课时类型
  getGiveType(params) {
    return post('/Publiclib/getGiveType', params)
  },
  // 商品套餐-套餐列表
  getItemList(params) {
    return post('/Product/getItemList', params)
  },
  // 商品套餐-移除套餐
  changeRemoveItem(params) {
    return post('/Product/changeRemoveItem', params)
  },
  // 商品套餐-新增商品
  improveItem(params) {
    return post('/Product/improveItem', params)
  },
  // 商品套餐-新增畅享套餐
  improveFreeItem(params) {
    return post('/Product/improveFreeItem', params)
  },
  // 修改学员基本信息
  improveBasic(params) {
    return post('/Student/improveBasic', params)
  },
  // 按校区获取统计数据
  getDataForShop(params) {
    return post('/Statistics/getDataForShop', params)
  },
  // 按校区获取统计数据
  getDataForShopByDate(params) {
    return post('/Statistics/getDataForShopByDate', params)
  },
  // 按校区获取统计数据
  getDataForAccount(params) {
    return post('/Statistics/getDataForAccount', params)
  },
  // 导入目标计划数据
  changeTarget(params) {
    return post('/Excelupload/changeTarget', params)
  },
  // 批量导入Leads
  appendLeads(params) {
    return post('/Excelupload/appendLeads', params)
  },
  // 批量导入学员
  appendChildren(params) {
    return post('/Excelupload/appendChildren', params)
  },
  // 公司 -账户概览
  getAccountSummary(params) {
    return post('/Company/getAccountSummary', params)
  },
  // 公司 - 乐币流水
  getCapitalFlow(params) {
    return post('/Company/getCapitalFlow', params)
  },
  // 公司 - 账单列表
  getBillList(params) {
    return post('/Company/getBillList', params)
  },
  // 公司 - 账单详情
  getBillInfo(params) {
    return post('/Company/getBillInfo', params)
  },
  // 公司 - 年费充值
  setAnnualFee(params) {
    return post('/Company/setAnnualFee', params)
  },
  // 套餐 - 套餐配置列表
  getShopItemList(params) {
    return post('/product/getShopItemList', params)
  },
  // 套餐 - 套餐分组列表：
  getItemTeamList(params) {
    return post('/product/getItemTeamList', params)
  },

  // 套餐 - 套餐分组转移：
  moveItemForTeam(params) {
    return post('/product/moveItemForTeam', params)
  },
  // 套餐 - 删除套餐分组
  delItemTeam(params) {
    return post('/product/delItemTeam', params)
  },
  // 套餐 - 编辑套餐分组
  editItemTeam(params) {
    return post('/product/editItemTeam', params)
  },
  // 套餐 - 添加套餐分组
  addItemTeam(params) {
    return post('/product/addItemTeam', params)
  },
  // 套餐 - 获取该分组下的套餐
  findItemTeams(params) {
    return post('/product/findItemTeams', params)
  },
  // 套餐 - 获取单个套餐分组信息
  findItemTeamInfo(params) {
    return post('/product/findItemTeamInfo', params)
  },
  // 套餐 - 移除套餐：
  delItemForTeam(params) {
    return post('/product/delItemForTeam', params)
  },
  // 套餐 - 分配套餐：
  assignItemTeam(params) {
    return post('/product/assignItemTeam', params)
  },
  // 套餐 - 配置分组：
  assignShopItem(params) {
    return post('/product/assignShopItem', params)
  },
  // 综合 - 配置分组：
  getSingleSelect(url) {
    return post(url)
  },
  // 每日套餐 - 获取套餐配置：
  getDeploy() {
    return post('/meal/getDeploy')
  },
  // 每日套餐 - 获取菜谱：
  getRecipeList(params) {
    return post('/meal/recipeList', params)
  },
  // 每日套餐 - 获取菜品列表：
  getFoodList(params) {
    return post('/meal/foodList', params)
  },
  // 每日套餐 - 删除菜品：
  delFoodList(params) {
    return post('/meal/delFood', params)
  },
  // 每日套餐 - 添加菜品：
  addFood(params) {
    return post('/meal/improveFood', params)
  },
  // 每日套餐 - 搜索菜谱
  addRecipeFoodList(params) {
    return post('/meal/addRecipeFoodList', params)
  },
  // 每日套餐 - 添加套餐
  addRecipe(params) {
    return post('/meal/addRecipe', params)
  },
  // 每日套餐 - 订餐统计
  orderFoodStatistics(params) {
    return post('/meal/orderFoodStatistics', params)
  },
  // 每日套餐 - 充值记录
  resetRecord(params) {
    return post('/meal/resetRecord', params)
  },
  // 每日套餐 - 充值记录
  recipeContent(params) {
    return post('/meal/recipeContent', params)
  },
  // 每日套餐 - 发布食谱
  sendMeal(params) {
    return post('/meal/sendMeal', params)
  },
  // 每日套餐 - 删除菜谱
  delRecipe(params) {
    return post('/meal/delRecipe', params)
  },
  // 店铺配置 - 获取店铺环境监测点位列表
  getPointPositionList(params) {
    return post('Company/getPointPositionList', params)
  },
  // 店铺配置 - 教室绑定点位
  bindingPointPosition(params) {
    return post('Company/bindingPointPosition', params)
  },
  // 猫头鹰股金 - 获取行权周期列表
  getExerciseScheduleList(params) {
    return post('Stock/getExerciseScheduleList', params)
  },
  // 猫头鹰股金 - 获取行权周期详情
  getExerciseScheduleInfo(params) {
    return post('Stock/getExerciseScheduleInfo', params)
  },
  // 猫头鹰股金 - 添加行权周期
  improveExerciseSchedule(params) {
    return post('Stock/improveExerciseSchedule', params)
  },
  // 猫头鹰股金 - 关闭行权周期
  closeExerciseSchedule(params) {
    return post('Stock/closeExerciseSchedule', params)
  },
  // 猫头鹰股金 - 待发放股金列表
  getWarehomeList(params) {
    return post('Stock/getWarehomeList', params)
  },
  // 猫头鹰股金 - 一键发放股金
  giveCapital(params) {
    return post('Stock/giveCapital', params)
  },
  // 猫头鹰股金 - 获取部门列表
  getDepartmentList(params) {
    return post('Stock/getDepartmentList', params)
  },
  // 猫头鹰股金 - 按部门或者姓名获取员工列表
  getUserList(params) {
    return post('Stock/getUserList', params)
  },
  // 猫头鹰股金 - 获取最新股价
  getLatestSharePrice(params) {
    return post('Stock/getLatestSharePrice', params)
  },
  // 猫头鹰股金 - 记录待发放股金
  recordWarehouse(params) {
    return post('Stock/recordWarehouse', params)
  },
  // 猫头鹰股金 - 记录待发放股金(发放股金添加)
  getStockMarketList(params) {
    return post('Stock/getStockMarketList', params)
  },
  // 猫头鹰股金 - 确认交易
  confirmDeal(params) {
    return post('Stock/confirmDeal', params)
  },
  // 猫头鹰股金 - 确认打款
  confirmPayment(params) {
    return post('Stock/confirmPayment', params)
  },
  // 猫头鹰股金 - 获取股价列表
  getSharePriceList(params) {
    return post('Stock/getSharePriceList', params)
  },
  // 猫头鹰股金 - 新增股价
  recordSharePrice(params) {
    return post('Stock/recordSharePrice', params)
  },
  // 猫头鹰股金 - 获取股金奖励类型
  getAwardType(params) {
    return post('Stock/getAwardType', params)
  },
  // 猫头鹰股金 - 员工股金
  getUserStockList(params) {
    return post('Stock/getUserStockList', params)
  },
  // 猫头鹰股金 - 员工获取股权详情
  getUserEquityCapitalList(params) {
    return post('Stock/getUserEquityCapitalList', params)
  },
  // 猫头鹰股金 - 撤销行权
  revocationCapital(params) {
    return post('Stock/revocationCapital', params)
  },
  // 猫头鹰股金 - 取消待发放股金登记
  revocationWarehouseCheckIn(params) {
    return post('Stock/revocationWarehouseCheckIn', params)
  },
  // 质检管理 - 质检项目
  getProjectList(params) {
    return post('/QualityTesting/projectList', params)
  },
  // 质检管理 - 删除质检项目
  delProject(params) {
    return post('/QualityTesting/delProject', params)
  },
  // 质检管理 - 编辑质检项目
  editProject(params) {
    return post('/QualityTesting/editProject', params)
  },
  // 质检管理 - 质检记录
  getQualityTestingRecordList(params) {
    return post('/QualityTesting/getQualityTestingRecordList', params)
  },
  // 总部监管 - 获取工单列表
  getWorkOrderList(params) {
    return post('/Employee/getWorkOrderList', params)
  },
  // 总部监管 - 是否公示
  changeWorkOrderOpen(params) {
    return post('/Employee/changeWorkOrderOpen', params)
  },
  // 总部监管 - 结单
  workOrderEnd(params) {
    return post('/Employee/workOrderEnd', params)
  },
  // 总部监管 - 回复
  replyWorkOrder(params) {
    return post('/Employee/replyWorkOrder', params)
  },
  // 总部监管 - 转介绍记录
  turnStudentList(params) {
    return post('/Student/turnStudentList', params)
  },
  // 总部监管 - 未回访预警学员
  unVisitStudentList(params) {
    return post('/Student/unVisitStudentList', params)
  },
  // 题优优 - 获取套餐列表
  getTyyShopItemList(params) {
    return post('/product/getTyyShopItemList', params)
  },
  // 题优优 - 创建套餐
  tyyImproveItem(params) {
    return post('/product/tyyImproveItem', params)
  },
  // 题优优 - 开启/关闭套餐
  tyyChangeRemoveItem(params) {
    return post('/product/changeRemoveItem', params)
  },
  // 题优优 - 宝典列表
  tyyValuableList(params) {
    return post('/product/tyyValuableList', params)
  },
  // 题优优 - 删除宝典
  tyyDelValuable(params) {
    return post('/product/delValuable', params)
  },
  // 题优优 - 删除宝典
  tyyImproveValuable(params) {
    return post('/product/tyyImproveValuable', params)
  },
  // 题优优 - 根据ID获取宝典
  tyyValuableRowById(params) {
    return post('/product/tyyValuableRowById', params)
  },
  // 题优优 - 直播列表
  tyyGetLiveList(params) {
    return post('/valuable/getLiveList', params)
  },
  // 题优优 - 删除直播
  tyyDelLive(params) {
    return post('/valuable/delLive', params)
  },
  // 题优优 - 获取教材版本
  tyyGetTextBook(params) {
    return post('/valuable/getTextBook', params)
  },
  // 题优优 - 编辑/创建直播
  tyyEditLive(params) {
    return post('/valuable/editLive', params)
  },
  // 题优优 - 直播详情
  tyyGetLiveRow(params) {
    return post('/valuable/getLiveRow', params)
  },
  // 题优优 - 直播预约记录
  tyyLiveReserveList(params) {
    return post('/valuable/liveReserveList', params)
  },
  // 题优优 - 知识点管理列表
  tyyKnowledgePointList(params) {
    return post('/valuable/knowledgePointList', params)
  },
  // 题优优 - 知识点管理列表
  tyyEditKnowledgePoint(params) {
    return post('/valuable/editKnowledgePoint', params)
  },
  // 题优优 - 删除知识点
  tyyDelKnowledgePoint(params) {
    return post('/valuable/delKnowledgePoint', params)
  },
  // 题优优 - 知识点详情
  tyyGetKnowledgePointRow(params) {
    return post('/valuable/getKnowledgePointRow', params)
  },
  // 题优优 - 签约订单
  tyyGetTyyOrderList(params) {
    return post('/order/getTyyOrderList', params)
  },
  // 题优优 - 获取学员列表
  tyyGetTyyStudentsList(params) {
    return post('/student/getTyyStudentsList', params)
  },
  // 题优优 - 增减积分
  tyyEditPoint(params) {
    return post('/student/editPoint', params)
  },
  // 题优优 - 学生积分流水
  tyyPointNote(params) {
    return post('/student/pointNote', params)
  },
  // 题优优 - 双周测评记录列表
  tyyGetCorrectHomeworkList(params) {
    return post('/Valuable/getCorrectHomeworkList', params)
  },
  // 题优优 - 确认测评反馈
  tyyFinishCorrect(params) {
    return post('/Valuable/finishCorrect', params)
  },
  // 题优优 - 退费单列表
  tyyGetRefundList(params) {
    return post('/Valuable/getRefundList', params)
  },
  // 题优优 - 退款详情
  tyyRefundRow(params) {
    return post('/Valuable/refundRow', params)
  },
  // 题优优 - 退款详情
  tyyPresidentOrLeaderAudit(params) {
    return post('/Valuable/presidentOrLeaderAudit', params)
  },
  // 题优优 - 退款详情
  tyyGeneralAudit(params) {
    return post('/Valuable/generalAudit', params)
  },
  // 题优优 - 退款详情
  tyyTrainList(params) {
    return post('/Valuable/trainList', params)
  },
  // 题优优 - 获取发票信息
  tyyGetInvoice(params) {
    return post('/Order/getInvoice', params)
  },
  // 题优优 - 设置发票信息
  tyySetInvoice(params) {
    return post('/Order/setInvoice', params)
  },
  // 题优优 - 数据统计营收数据
  tyyRevenueStatistic(params) {
    return post('/Valuable/revenueStatistic', params)
  },
  // 题优优 - 数据统计运营数据
  tyyOperateStatistic(params) {
    return post('/Valuable/operateStatistic', params)
  },
  // 公司管理 - 获取应用列表
  getAppList(params) {
    return post('/Payconfig/getAppList', params)
  },
  // 公司管理 - 创建应用
  createApp(params) {
    return post('/Payconfig/createApp', params)
  },
  // 公司管理 - 修改应用
  improveAppName(params) {
    return post('/Payconfig/improveAppName', params)
  },
  // 公司管理 - 获取应用渠道列表
  getChannelList(params) {
    return post('/Payconfig/getChannelList', params)
  },
  // 公司管理 - 获取渠道详情
  getChannelInfo(params) {
    return post('/Payconfig/getChannelInfo', params)
  },
  // 公司管理 - 编辑支付渠道详情
  improveChannelInfo(params) {
    return post('/Payconfig/improveChannelInfo', params)
  },
  // 公司管理 - 一键同步节点
  syncNode(params) {
    return post('/Payconfig/syncNode', params)
  },
  // 公司管理 - 获取节点列表
  getNodeList(params) {
    return post('/Payconfig/getNodeList', params)
  },
  // 公司管理 - 更新节点信息
  improveNode(params) {
    return post('/Payconfig/improveNode', params)
  },
  // 总部监管 - 获得调查问卷列表
  getQuestionnaireList(params) {
    return post('/Questionnaire/getQuestionnaireList', params)
  },
  // 总部监管 - 获取问卷详情
  getQuestionnaireTemplateInfo(params) {
    return post('/Questionnaire/getQuestionnaireTemplateInfo', params)
  },
  // 总部监管 - 获取问卷详情
  improveQuestionnaire(params) {
    return post('/Questionnaire/improveQuestionnaire', params)
  },
  // 组件  - 查询托管适用学员
  getConditonSub(params) {
    return post('/Questionnaire/getConditonSub', params)
  },
  // 总部监管  - 发布调查
  releaseWeekReport(params) {
    return post('/Questionnaire/releaseWeekReport', params)
  },
  // 总部监管  - 获取问卷分析数据
  getQuestionnaireStatistics(params) {
    return post('/Questionnaire/getQuestionnaireStatistics', params)
  },
  // 优豆管理  - 获得积分课时商品列表
  getItemCreditsExchangeList(params) {
    return post('/Product/getItemCreditsExchangeList', params)
  },
  // 优豆管理  - 获得积分课时商品列表
  createCreditsExchangeItem(params) {
    return post('/Product/createCreditsExchangeItem', params)
  },
  // 优豆管理  - 移除优豆商品
  removeCreditsExchangeItem(params) {
    return post('/Product/removeCreditsExchangeItem', params)
  },
  // 优豆管理  - 家长积分列表
  masterPointList(params) {
    return post('/Mallgift/masterPointList', params)
  },
  // 优豆管理  - 修改优豆
  updatePoint(params) {
    return post('/Mallgift/updatePoint', params)
  },
  // 优豆管理  - 修改优豆
  masterPointFlow(params) {
    return post('/Mallgift/masterPointFlow', params)
  },
  // 课程内容 - 获取列表
  getClassContentList(params) {
    return post('/Schedule/getClassContentList', params)
  },
  // 课程内容 - 删除
  removeClassContent(params) {
    return post('/Schedule/removeClassContent', params)
  },
  // 课程内容 - 编辑新增
  improveClassContent(params) {
    return post('/Schedule/improveClassContent', params)
  },
  // 课程内容 - 获取详情
  getClassContentInfo(params) {
    return post('/Schedule/getClassContentInfo', params)
  },
  // 排课 - 获取列表
  getScheduleList(params) {
    return post('/Schedule/getList', params)
  },
  // 排课 - 编辑排课信息
  updateSchedule(params) {
    return post('/Schedule/updateSchedule', params)
  },
  // 排课 - 按店铺获取教室列表
  getSpaceListByShopId(params) {
    return post('/Schedule/getSpaceListByShopId', params)
  },
  // 排课 - 按职能获取老师
  getTeacherListBySubject(params) {
    return post('/Schedule/getTeacherListBySubject', params)
  },
  // 排课 - 创建排课
  createSchedule(params) {
    return post('/Schedule/createSchedule', params)
  },
  // 排课 - 创建排课
  getClassDateList(params) {
    return post('/Schedule/getClassDateList', params)
  },
  // 排课 - 获取详情
  getClassScheduleInfo(params) {
    return post('/Schedule/getClassScheduleInfo', params)
  },
  // 活动 - 活动游学列表
  getActivityList(params) {
    return post('/Learnmore/getActivityList', params)
  },
  // 活动 - 新增编辑游学活动
  improveActivity(params) {
    return post('/Learnmore/improveActivity', params)
  },
  // 活动 - 获取抽奖列表
  getActivityLuckyList(params) {
    return post('/Activity/getActivityList', params)
  },

  // 活动 - 新增编辑抽奖活动
  improveLucyActivity(params) {
    return post('/Activity/improveActivity', params)
  },

  // 活动 - 获取抽奖活动详情
  getLuckyActivityInfo(params) {
    return post('/Activity/getActivityInfo', params)
  },

  // 活动 - 获取抽奖活动奖品列表
  getLuckyGoodsList(params) {
    return post('/Activity/getGoodsList', params)
  },

  // 活动 - 编辑抽奖活动奖品
  improveAcitveGoods(params) {
    return post('/Activity/improveGoods', params)
  },

  // 活动 - 删除抽奖活动奖品
  deleteLuckyAcitveGoods(params) {
    return post('/Activity/deleteGoods', params)
  },

  // 活动 - 获取参与抽奖活动的用户列表
  getLuckyActiveUserList(params) {
    return post('/Activity/getUserList', params)
  },

  // 活动 - 新增编辑抽奖活动用户
  improveLuckyUser(params) {
    return post('/Activity/improveUser', params)
  },

  // 活动 - 获取中奖记录
  getLuckyRecordList(params) {
    return post('/Activity/getRecordList', params)
  },

  // 活动 - 活动导入学员
  importJoinList(params) {
    return post('/Learnmore/importJoinList', params)
  },
  // 活动 - 修改活动时间
  updateActivityBeginDay(params) {
    return post('/Learnmore/updateActivityBeginDay', params)
  },
  // 活动 - 修改活动成本
  updateActivityCost(params) {
    return post('/Learnmore/updateActivityCost', params)
  },
  // 活动 - 活动报名列表
  getActivityApplyList(params) {
    return post('/Learnmore/getActivityApplyList', params)
  },
  // 活动 - 活动报名列表
  removeJoinSub(params) {
    return post('/Learnmore/removeJoinSub', params)
  },
  // 活动 - 获取学员剩余课时列表
  getSubSellingValueList(params) {
    return post('/Learnmore/getSubSellingValueList', params)
  },
  // 活动 - 获取学员剩余课时列表
  transitionSellingValue(params) {
    return post('/Learnmore/transitionSellingValue', params)
  },
  // 活动 - 转换课时记录
  getChangeFlowList(params) {
    return post('/Learnmore/getChangeFlowList', params)
  },
  // 黄静 - 复课
  HJResumeClasses(params) {
    return post('/Student/resumeClasses', params)
  },
  // 公司管理 - 获取合同列表
  getContractList(params) {
    return post('/company/getContractList', params)
  },
  // 公司管理 -  获取合同详情
  getContractInfo(params) {
    return post('/company/getContractInfo', params)
  },
  // 公司管理 - 编辑合同详情
  improveContract(params) {
    return post('/company/improveContract', params)
  },
  // 课表管理 - 按科目获取课程列表
  getClassNameBySubject(params) {
    return post('/Schedule/getClassNameBySubject', params)
  },
  // 店铺管理 - 配置额外信息
  setShopValue(params) {
    return post('/Company/setShopValue', params)
  },
  // 店铺管理 - 获取额外信息
  getShopValue(params) {
    return post('/Company/getShopValue', params)
  },
  // 店铺管理 - 获取人脸识别设备列表
  getShopValueList(params) {
    return post('/Company/getShopValueList', params)
  },
  // 店铺管理 - 删除人脸识别列表
  delShopValue(params) {
    return post('/Company/delShopValue', params)
  },
  // 店铺管理 - 初始化设备
  initializeDevice(params) {
    return post('/Company/initializeDevice', params)
  },
  // 店铺管理 - 重启设备
  rebootDevice(params) {
    return post('/Company/rebootDevice', params)
  },
  // 店铺管理 - 获取 V3 人脸设备列表
  getFaceDeviceV3List(params) {
    return post('/FaceDeviceV3/getList', params)
  },
  // 店铺管理 - 保存 V3 人脸设备
  saveFaceDeviceV3(params) {
    return post('/FaceDeviceV3/save', params)
  },
  // 店铺管理 - 启用或停用 V3 人脸设备
  setFaceDeviceV3Enabled(params) {
    return post('/FaceDeviceV3/setEnabled', params)
  },
  // 店铺管理 - 逻辑删除 V3 人脸设备
  deleteFaceDeviceV3(params) {
    return post('/FaceDeviceV3/deleteDevice', params)
  },
  // 店铺管理 - 获取 V3 人脸设备默认配置
  getFaceDeviceV3ConfigTemplate(params) {
    return post('/FaceDeviceV3/getConfigTemplate', params)
  },
  // 店铺管理 - 初始化 V3 人脸设备配置
  initializeFaceDeviceV3(params) {
    return post('/FaceDeviceV3/initializeDevice', params)
  },
  // 店铺管理 - 通知 V3 人脸设备检查更新
  checkFaceDeviceV3Update(params) {
    return post('/FaceDeviceV3/checkUpdate', params)
  },
  // 店铺管理 - 同步单个学员到 V3 人脸设备
  syncFaceDeviceV3Person(params) {
    return post('/FaceDeviceV3/syncPerson', params)
  },
  // 店铺管理 - 从 V3 人脸设备删除单个学员
  deleteFaceDeviceV3Person(params) {
    return post('/FaceDeviceV3/deletePerson', params)
  },
  // 店铺管理 - 小批量同步 V3 人脸设备人员
  refreshFaceDeviceV3People(params) {
    return post('/FaceDeviceV3/refresh', params)
  },
  // 店铺管理 - 查询 V3 人脸设备命令状态
  getFaceDeviceV3CommandList(params) {
    return post('/FaceDeviceV3/getCommandList', params)
  },
  // 问卷调查 - 复制问卷
  copyQuestionnaire(params) {
    return post('/Questionnaire/copyQuestionnaire', params)
  },
  // 题目管理-获取已生成练习列表
  getTeacherExercisesList(params) {
    return post('/Question/getTeacherExercisesList', params)
  },
  // 题目管理-搜索练习题列表
  searchQuestionList(params) {
    return post('/Question/searchQuestionList', params)
  },
  // 题目管理-生成练习记录
  setQuestionExercises(params) {
    return post('/Question/setQuestionExercises', params)
  },
  // 财务审核-家长提现审核列表
  getFinanceWithdrawList(params) {
    return post('/Order/getFinanceWithdrawList', params)
  },
  // 财务审核-家长提现审核备注信息
  setFinanceWithdrawRemark(params) {
    return post('/Order/setFinanceWithdrawRemark', params)
  },
  // 财务审核-家长提现审核
  financeWithdrawAudit(params) {
    return post('/Order/financeWithdrawAudit', params)
  },
  // 财务审核-天天陪读签约查询
  ttpdGetOrderList(params) {
    return post('/Online/getOrderList', params)
  },
  // 财务审核-天天陪读签约订单详情
  ttpdGetOrderInfo(params) {
    return post('/Online/getOrderInfo', params)
  },
  // 财务审核-天天陪读退款查询
  ttpdGetRefundList(params) {
    return post('/Online/getRefundList', params)
  },
  // 财务审核-天天陪读退款订单详情
  ttpdGetRefundInfo(params) {
    return post('/Online/getRefundInfo', params)
  },
  // 转换课时-获取学员及剩余课时信息
  getSubInfoAndValueList(params) {
    return post('/Operation/getSubBusinessValue', params)
  },
  setChangeSubValue(params) {
    return post('/Operation/transferBusinessValue', params)
  },
  // 批改张数统计
  getChannelFeeFlow(params) {
    return post('/Operation/getChannelFeeFlow', params)
  },
  // 获取配置开关
  getCompanySwitch(params) {
    return post('/Company/getSwitch', params)
  },
  // 获取午托时间段
  getNoonTime(params) {
    return post('/Configuration/getNoonTime', params)
  },
  // 设置午托时间段
  setNoonTime(params) {
    return post('/Configuration/setNoonTime', params)
  },
  // 设置配置信息
  setConfiguration(params) {
    return post('/Company/setConfiguration', params)
  },
  // 获取配置信息
  getConfiguration(params) {
    return post('/Company/getConfiguration', params)
  },
  // 获取配置信息
  reportList(params) {
    return post('/Report/reportList', params)
  },
  // 获取配置信息
  getQuickReplyList(params) {
    return post('/Schedule/getQuickReplyList', params)
  },
  // 设置快捷回复日期对应的内容
  setQuickReply(params) {
    return post('/Schedule/setQuickReply', params)
  },
  // 修改快捷回复内容
  changeQuickReply(params) {
    return post('/Schedule/changeQuickReply', params)
  },
  // 删除一条快捷回复
  removeQuickReply(params) {
    return post('/Schedule/removeQuickReply', params)
  },
  // 获取奖惩列表
  getBonusPenaltyList(params) {
    return post('/Purchasegoods/getBonusPenaltyList', params)
  },
  // 删除奖惩
  bonusPenaltyRemove(params) {
    return post('/Purchasegoods/bonusPenaltyRemove', params)
  },
  // 设置奖惩
  bonusPenaltySubmit(params) {
    return post('/Purchasegoods/bonusPenaltySubmit', params)
  },
  // 获取积分管理列表
  getPointManageList(params) {
    return post('/Purchasegoods/getPointManageList', params)
  },
  // 学员积分流水详情
  getPointManageFlow(params) {
    return post('/Purchasegoods/getPointManageFlow', params)
  },
  // 调整积分
  adjustPoint(params) {
    return post('/Purchasegoods/adjustPoint', params)
  },
  // 获取物品列表
  getGoodsList(params) {
    return post('/Purchasegoods/getGoodsList', params)
  },
  // 上下架删除物品
  launchAndRetireAndDeleteGoods(params) {
    return post('/Purchasegoods/launchAndRetireAndDeleteGoods', params)
  },
  // 物品库存变更历史记录
  getStockHistoryList(params) {
    return post('/Purchasegoods/getStockHistoryList', params)
  },
  // 调整物品库存数量
  changeGoodsStock(params) {
    return post('/Purchasegoods/changeGoodsStock', params)
  },
  // 调整物品库存损耗
  changeGoodsLoss(params) {
    return post('/Purchasegoods/changeGoodsLoss', params)
  },
  // 新增编辑物品
  setGoods(params) {
    return post('/Purchasegoods/setGoods', params)
  },
  // 校区采购合约开关列表
  shopPurchaseNoteSwitch(params) {
    return post('/Purchasegoods/shopPurchaseNoteSwitch', params)
  },
  // 合约开关开启关闭
  setShopPurchaseNoteSwitch(params) {
    return post('/Purchasegoods/setShopPurchaseNoteSwitch', params)
  },
  // 校区采购合约开关初始化
  shopPurchaseNoteSwitchInit(params) {
    return post('/Purchasegoods/shopPurchaseNoteSwitchInit', params)
  },
  // 获取审核列表
  getAuditList(params) {
    return post('/Purchasegoods/getAuditList', params)
  },
  // 管理员锁定合约单
  adminLockNote(params) {
    return post('/Purchasegoods/adminLockNote', params)
  },
  // 提交审核
  auditSubmit(params) {
    return post('/Purchasegoods/auditSubmit', params)
  },
  // 包裹待确认收货获取列表
  packageConfirmedForReceiptList(params) {
    return post('/Purchasegoods/packageConfirmedForReceiptList', params)
  },
  // 确认收货
  confirmReceipt(params) {
    return post('/Purchasegoods/confirmReceipt', params)
  },
  // 更新快递单号
  updateExpressNo(params) {
    return post('/Purchasegoods/updateExpressNo', params)
  },
  // 获取未填写包裹信息列表
  notHaveExpressInfoPackageList(params) {
    return post('/Purchasegoods/notHaveExpressInfoPackageList', params)
  },
  // 填写快递信息
  confirmExpressInfo(params) {
    return post('/Purchasegoods/confirmExpressInfo', params)
  },
  // 获取校区物品管理列表
  getShopStockList(params) {
    return post('/Purchasegoods/getShopStockList', params)
  },
  // 搜索上架物品
  seachGoodsList(params) {
    return post('/Purchasegoods/seachGoodsList', params)
  },
  // 校区新增物品
  addShopGoods(params) {
    return post('/Purchasegoods/addShopGoods', params)
  },
  // 校区调整库存
  changeShopStock(params) {
    return post('/Purchasegoods/changeShopStock', params)
  },
  // 查看库存变更日志
  getShowChangeLog(params) {
    return post('/Purchasegoods/getShowChangeLog', params)
  },
  // 清空校区商品库存
  clearShopGoodsStocks(params) {
    return post('/Purchasegoods/clearShopGoodsStocks', params)
  },
  // 签到数据
  signCount(params) {
    return post('/Graph/signCount', params)
  },
  // 当日家长现金付款
  income(params) {
    return post('/Graph/income', params)
  },
  // 课耗收入
  consume(params) {
    return post('/Graph/consume', params)
  },
  // 托管宝待开发票列表
  getTgbInvoiceList(params) {
    return post('/Order/getTgbInvoiceList', params)
  },
  // 托管宝待开发票审核
  auditTgbInvoice(params) {
    return post('/Order/auditTgbInvoice', params)
  },
  // 变动家长余额
  masterMoneySubmit(params) {
    return post('/Master/masterMoneySubmit', params)
  },
  // 手动变动余额记录
  getMasterBillChangeList(params) {
    return post('/Master/getMasterBillChangeList', params)
  },
  // 获取家长余额
  getMasterMoney(params) {
    return post('/Master/getMasterMoney', params)
  },
  // 家长余额流水
  getMasterBillFlow(params) {
    return post('/Master/getMasterBillFlow', params)
  },
  // 流水记录
  getBalanceStatementList(params) {
    return post('/Order/getBalanceStatementList', params)
  },
  // 获取产品建议列表
  getSuggestionList(params) {
    return post('/Employee/getSuggestionList', params)
  },
  // 获取产品建议类型列表
  getSuggestionType(params) {
    return post('/Employee/getSuggestionType', params)
  },
  // 处理回复
  replySuggestion(params) {
    return post('/Employee/replySuggestion', params)
  },
  // 复课审核列表
  getReviewOfResumptionOfClasses(params) {
    return post('/Audit/getReviewOfResumptionOfClasses', params)
  },
  // 审核复课上传凭证
  changeReviewOfResumptionOfClassesStatus(params) {
    return post('/Audit/changeReviewOfResumptionOfClassesStatus', params)
  },
  // 套餐额外费用类型列表
  getTypeList(params) {
    return post('/Additional/getTypeList', params)
  },
  // 套餐额外费用添加类型
  improveType(params) {
    return post('/Additional/improveType', params)
  },
  // 套餐额外费用删除类型
  deleteType(params) {
    return post('/Additional/deleteType', params)
  },
  // 套餐额外费用费用列表
  getProductList(params) {
    return post('/Additional/getProductList', params)
  },
  // 套餐额外费用添加费用
  improveProduct(params) {
    return post('/Additional/improveProduct', params)
  },
  // 套餐额外费用删除费用
  deleteProduct(params) {
    return post('/Additional/deleteProduct', params)
  },
  // 优惠券列表
  getCouponList(params) {
    return post('/Coupon/getList', params)
  },
  // 优惠券规则添加
  improveCoupon(params) {
    return post('/Coupon/improve', params)
  },
  // 优惠券删除
  removeCoupon(params) {
    return post('/Coupon/removeCoupon', params)
  },
  // 优惠券启用停用
  openCloseCoupon(params) {
    return post('/Coupon/openCloseCoupon', params)
  },
  // 发放优惠券
  distributeCoupons(params) {
    return post('/Coupon/distributeCoupons', params)
  },
  // 删除用户未使用优惠券
  delUserCoupon(params) {
    return post('/Coupon/delUserCoupon', params)
  },
  // 优惠券使用列表
  getCouponUseList(params) {
    return post('/Coupon/getCouponUseList', params)
  },
  // 支付单待财务审核列表
  getBillingAuditList(params) {
    return post('/Buy/getList', params)
  },
  // 获取支付单详情
  getBillingDetail(params) {
    return post('/Buy/getDetail', params)
  },
  // 审核财务订单
  auditBilling(params) {
    return post('/Buy/auditOrder', params)
  },
  // 后台停课
  stopClass(params) {
    return post('/Student/stopClasses', params)
  },
  // 升年级
  setUpgrade(params) {
    return post('/Configuration/setUpgrade', params)
  },
  // 获取升年级记录
  getUpgradeList(params) {
    return post('/Configuration/getUpgradeList', params)
  },
  // 关闭套餐前置，是否有未使用的定金
  checkItemClose(params) {
    return post('/Product/checkItemClose', params)
  },
  // 获取套餐列表按类型
  getPayItemList(params) {
    return post('/Product/getPayItemList', params)
  },
  // 更新未使用的定金绑定套餐
  changeDepositItem(params) {
    return post('/Additional/changeDepositItem', params)
  },
  // 获取完整手机号码
  getMobile(params) {
    return post('/show/getMobile', params)
  },
  // 设置批改节点
  setAssistantNode(params) {
    return post('/Company/setAssistantNode', params)
  },
  // 设置是否是假期
  setHoliday(params) {
    return post('/Company/setHoliday', params)
  },
  // 获取余额检测
  balanceCheck(params) {
    return post('/Order/balanceCheck', params)
  },
  // 组件  - 查询小班课适用学员
  getWeekendConditonSub(params) {
    return post('/Questionnaire/getWeekendConditonSub', params)
  },
  // 取消发送问卷 延时发送时
  cancelReleaseQuestionnaire(params) {
    return post('/Questionnaire/cancelRelease', params)
  },
  // 获取小班课科目列表
  getSmallClassSubject(params) {
    return post('/Publiclib/getSmallClassSubject', params)
  }

}

export default http
